import { ReactNode } from "react";

/** Stands in for Page / Container when a screen is shown inside another frame (the Settings tabs). */
export const Passthrough = ({ children }: { children?: ReactNode }) => <>{children}</>;
